module.exports = __webpack_public_path__ + "img/timed-salegoods.e1186567.svg";